import axios from 'axios';
import { notification } from 'antd';
import get from 'lodash/get';
import { LOGOUT } from '../constants/routes';

const configureAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 250000,
  });

const axiosInstance = configureAxios();

axiosInstance.interceptors.request.use((config) => config);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (err) => {
    if (!get(err, 'response')) {
      notification.error({
        message: 'Something Went wrong',
        className: 'error-notification',
        description: 'Please try again or contact technical team',
      });
    } else {
      notification.error({
        message: get(err, 'response.data.message'),
        className: 'error-notification',
      });
      if (get(err, 'response.status') === 401) {
        // eslint-disable-next-line no-undef
        window.location.replace(LOGOUT);
      }
    }

    throw err;
  }
);

export default axiosInstance;
